import React from "react";
import { useApiCache, ApiStateType } from "customHooks/useApi";
import { useAuthState } from "_ReactContext/AuthContext";

export const useJobApprovalCustomLists: (
    t: any
) => [Compleo.CustomLists.ListDefinitionType[], boolean] = (t: any) => {
    const { company } = useAuthState();
    const companyId = company.companyId || "0";

    const [ready, setReady] = React.useState<boolean>(false);
    const [listDefinition] = React.useState<
        Compleo.CustomLists.ListDefinitionType[]
    >([]);
    // "selectionTypeList_all": "All [[job[pluralForm]]]",
    // "selectionTypeList_customers": "[[customer[pluralForm]]]",
    // "selectionTypeList_branches": "[[branch[pluralForm]]]",
    // "selectionTypeList_jobCategory": "[[job[singularForm]]] Category"

    const selectionTypeValues = ["all", "customers", "branches", "jobCategory"];
    const selectionTypeList: Compleo.CustomLists.ListDefinitionType = {
        fieldName: "selectionType",
        data: selectionTypeValues.map((value) => ({
            itemValue: value,
            itemText: t(`selectionTypeList_${value}`)
        })),
        valueName: "itemValue",
        labelName: "itemText"
    };

    const [customers] = useApiCache(
        "/contact/dropdownlist",
        "post",
        { companyId: companyId },
        false,
        1000 * 60 * 2
    );

    const [branchs] = useApiCache(
        "/branch/dropdownlist",
        "post",
        { companyId: companyId },
        false,
        1000 * 60 * 2
    );

    if (
        customers.status === "success" &&
        !listFilled(listDefinition, "customers")
    ) {
        listDefinition.push({
            fieldName: "customers",
            data: customers.response.data,
            valueName: "itemValue",
            labelName: "itemText"
        });
    }

    if (
        branchs.status === "success" &&
        !listFilled(listDefinition, "branches")
    ) {
        listDefinition.push({
            fieldName: "branches",
            data: branchs.response.data,
            valueName: "itemValue",
            labelName: "itemText"
        });
    }

    if (!ready) {
        const readyModules = verifyRead([customers, branchs]);
        if (readyModules) {
            setReady(true);
        }
    }
    return [[...listDefinition, selectionTypeList], ready];
};

const verifyRead = (api: ApiStateType[]) => {
    return api.filter((a: ApiStateType) => a.status !== "success").length === 0;
};

const listFilled = (
    listDefinition: Compleo.CustomLists.ListDefinitionType[],
    fieldName: string
) => {
    return (
        listDefinition.filter((l: any) => l.fieldName === fieldName).length > 0
    );
};
